import styled from "styled-components";

const Container = styled.div``;

const Content = styled.div`
  .text {
    font-size: 1.2rem;
  }

  > :last-child {
    margin-top: 45px;
    float: right;
  }
`;

export { Container, Content };
